<button
  [class]="buttonClass()"
  [type]="type()"
  [disabled]="disabled()"
  [attr.aria-label]="ariaLabel() || null"
  (click)="clicked.emit($event)"
>
  <ng-content />
</button>
